import { render, staticRenderFns } from "./SideBarLogo.vue?vue&type=template&id=5d20a9c4&lang=true&"
import script from "./SideBarLogo.vue?vue&type=script&lang=js&"
export * from "./SideBarLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports